import { createFileRoute, redirect } from '@tanstack/react-router'
import { featureFlags } from '@/lib/feature-flags'
import { DashboardPersonalPage } from '@/pages/dashboard-personal/page'

export const Route = createFileRoute('/_protected/dashboard-personal')({
  beforeLoad: () => {
    if (!featureFlags.personalDashboard) {
      throw redirect({ to: '/' })
    }
  },
  component: DashboardPersonalPage,
})
